const seoConfig = {
  home: {
    title: 'Best IIT-JEE & NEET Coaching in Bikaner Since 1999',
    description:
      'Concept Classes - leading coaching institute in Bikaner for IIT-JEE, NEET-UG & Pre-Foundation. 25+ years of excellence with top results.',
    keywords:
      'IIT JEE coaching Bikaner, NEET coaching Bikaner, best coaching institute Bikaner, Concept Classes, JEE Advanced preparation, NEET UG coaching, pre-foundation courses Bikaner, Bhupendra Middha',
    canonicalPath: '/',
  },
  about: {
    title: 'About Concept Classes',
    description:
      'Learn about Concept Classes, founded in 1999 in Bikaner by Er. Bhupendra Middha. 25+ years of coaching excellence for IIT-JEE, NEET, and board exams with top-notch faculty.',
    keywords:
      'about Concept Classes, Concept Classes history, Bhupendra Middha, coaching institute Bikaner, Concept Classes story',
    canonicalPath: '/about',
  },
  engineering: {
    title: 'IIT-JEE Coaching Courses',
    description:
      'Explore IIT-JEE coaching courses at Concept Classes Bikaner: Early Lead (11th), Flight (12th), Eagle\'s Eye (Dropper), and Success Elevator. Expert faculty, proven results.',
    keywords:
      'IIT JEE coaching courses, JEE Main preparation Bikaner, JEE Advanced coaching, Early Lead course, Flight course, Eagle Eye course, engineering coaching Bikaner',
    canonicalPath: '/engineering',
  },
  medical: {
    title: 'NEET-UG Coaching Courses',
    description:
      'Explore NEET-UG coaching courses at Concept Classes Bikaner: Genesis (11th), Orchid (12th), Synapse (Dropper), and Crash Course. Expert biology, physics & chemistry faculty.',
    keywords:
      'NEET coaching courses Bikaner, NEET UG preparation, medical coaching Bikaner, Genesis course, Orchid course, Synapse course, AIIMS coaching',
    canonicalPath: '/medical',
  },
  preFoundation: {
    title: 'Pre-Foundation Courses (Class 9-10)',
    description:
      'Pre-Foundation courses at Concept Classes Bikaner for Class 9th and 10th students. Build a strong foundation for IIT-JEE and NEET with Focus and Laser programs.',
    keywords:
      'pre-foundation courses Bikaner, class 9 coaching, class 10 coaching, Focus course, Laser course, early preparation IIT NEET',
    canonicalPath: '/pre-foundation',
  },
  resultsEngineering: {
    title: 'IIT-JEE Results',
    description:
      'View IIT-JEE results of Concept Classes students. Consistent top ranks in JEE Main and JEE Advanced from Bikaner\'s leading engineering coaching institute.',
    keywords:
      'IIT JEE results Concept Classes, JEE Main results Bikaner, JEE Advanced results, engineering exam results',
    canonicalPath: '/results/engineering',
  },
  resultsMedical: {
    title: 'NEET Results',
    description:
      'View NEET-UG results of Concept Classes students. Outstanding selections in medical colleges from Bikaner\'s top NEET coaching institute.',
    keywords:
      'NEET results Concept Classes, NEET UG results Bikaner, medical exam results, AIIMS results',
    canonicalPath: '/results/medical',
  },
  resultsPreFoundation: {
    title: 'Pre-Foundation Results',
    description:
      'View Pre-Foundation results of Concept Classes students. Excellent board exam results and strong competitive exam foundation for Class 9th and 10th students.',
    keywords:
      'pre-foundation results Concept Classes, class 9 results, class 10 results, board exam results Bikaner',
    canonicalPath: '/results/pre-foundation',
  },
  images: {
    title: 'Photo Gallery',
    description:
      'Browse photos of Concept Classes Bikaner - campus, classrooms, labs, events, and student activities. See our world-class infrastructure for IIT-JEE and NEET coaching.',
    keywords:
      'Concept Classes photos, campus gallery, coaching institute images, Bikaner coaching centre',
    canonicalPath: '/images',
  },
  collegeSearch: {
    title: 'College Search Tool',
    description:
      'Find medical and engineering colleges by exam type, cutoff scores, and state. NEET college predictor and JEE counselling information tool by Concept Classes.',
    keywords:
      'NEET college search, JEE college predictor, medical college cutoff, engineering college counselling, college search tool',
    canonicalPath: '/college-search',
  },
  scienceChampResult: {
    title: 'Science Champ Result 2026',
    description:
      'Check your Science Champ 2026 exam results by Concept Classes Bikaner. Enter your roll number to view your scorecard, subject-wise marks, and percentage.',
    keywords:
      'Science Champ result 2026, Concept Classes exam result, science competition Bikaner, scholarship exam result',
    canonicalPath: '/science-champ-result-2026',
  },
  answerKey2027: {
    title: 'Science Champ 2027 Answer Key',
    description:
      'Provisional answer key of Concept Science Champ Scholarship cum Entrance Test 2027 for classes 6 to 12, all paper sets. Check your answers by class and set.',
    keywords:
      'Science Champ 2027 answer key, CSCST 2027 answer key, Concept Classes answer key, scholarship test answer key Bikaner',
    canonicalPath: '/science-champ-answer-key-2027',
  },
  result2027: {
    title: 'Science Champ 2027 Result',
    description:
      'Check your Concept Science Champ Scholarship cum Entrance Test 2027 result with your roll number and a code sent on WhatsApp to your registered mobile number.',
    keywords:
      'Science Champ 2027 result, CSCST 2027 result, Concept Classes result, scholarship test result Bikaner',
    canonicalPath: '/science-champ-result-2027',
  },
};

export default seoConfig;
